import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GenericModalData } from './generic-modal-data';
import { GenericModalComponent } from './generic-modal.component';
import { ComboDto } from 'src/app/dtos/combo-dto';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'justification-modal',
  templateUrl: './justification-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class JustificationModalComponent extends GenericModalComponent implements OnInit {

    id: number;

    constructor(@Inject(MAT_DIALOG_DATA) public data: GenericModalData, public dialogRef: MatDialogRef<GenericModalComponent>, private apiService: ApiService) {
        super(data, dialogRef);
    }

    ngOnInit(): void {
        if(!this.data.justifications) {
            this.loadCombo();
        } else {
            this.id = this.data.justifications[0].value;
        }
    }

    private loadCombo(): void {
        this.apiService.get<ComboDto[]>('api/Delivery/getJustificationCombo')
            .subscribe((response: ComboDto[]) => {
            if (response) {
                this.data.justifications = response;
                this.id = this.data.justifications[0].value;
            }
        });
    }

    onClickCancel(): void {
        this.dialogRef.close();
    }
}
